import { RunnableApplicationTabItem, ServerApplicationTabItem } from "./application";
import { EnvironmentTabItem } from "./environment";
import { JobTabItem } from "./job";
import { SecretTabItem } from "./secret";

export * from "./application";
export * from "./environment";
export * from "./job";
export * from "./secret";

export type TabItem =
  | EnvironmentTabItem
  | JobTabItem
  | RunnableApplicationTabItem
  | SecretTabItem
  | ServerApplicationTabItem;
